import React from 'react';

import AddMusicLinkForm from 'components/dashboard/music-links-content/AddMusicLinkForm';
import MusicLinkItemsList from 'components/dashboard/music-links-content/MusicLinkItemsList';

import './MusicLinksPageContent.css';

const MusicLinksPageContent = () => (
  <div className="dashboard-music-links-page-content__component">
    <div className="add-link-form">
      <AddMusicLinkForm />
    </div>

    <MusicLinkItemsList />
  </div>
);

export default MusicLinksPageContent;
